// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + {"176":"projects","417":"experience","485":"publications"}[chunkId] + "." + {"176":"a684659e","417":"247c430f","485":"f4789ef4"}[chunkId] + ".js";
};